import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

import {GET_JOBS} from './api';


import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {Paper } from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import noPostsFound from '../../homepage/images/no-posts.svg';

import {  Container , Row , Col  } from 'react-bootstrap';
import CardJob from '../../card-job';
import { Button } from '@material-ui/core';


export default function  LatestJobs(){
    const { loading, error, data , refetch } = useQuery(GET_JOBS);
    useEffect(()=>{
        refetch();
    },[]);
    if (error) return `Error! ${error.message}`;
    if(loading) {
        return (
        <div>
                <Container className="mt-5">
                    <Row className="justify-content-center align-items-center">
                        <Col md={2} xs={12} className="">
                            <Skeleton variant="rect" height={150} />
                        </Col>
                        <Col md={10}>
                            <Skeleton variant="text" width={150} />
                            <Skeleton variant="text" width={130} />
                            <Skeleton variant="text" width={250} />
                        </Col>
                    </Row>
                    <Row className="justify-content-center align-items-center mt-3">
                        <Col md={2} xs={12} className="">
                            <Skeleton variant="rect" height={150} />
                        </Col>
                        <Col md={10}>
                            <Skeleton variant="text" width={150} />
                            <Skeleton variant="text" width={130} />
                            <Skeleton variant="text" width={250} />
                        </Col>
                    </Row>
                </Container>
        </div>)
    }
    else{
        let jobs = data.me.ApplicationsGet?.data.filter(job => job.is_Done === true);
        console.log(jobs);
        if(!jobs.length > 0){
            return(<div>
                <Container className="pt-5">
                    <Paper elevation={3}>
                        <Row className="bg-light m-0 p-3" style={{borderBottom:'1px solid #f2f2f2'}}>
                            <Col xs={6}>
                                <h5>Latest Jobs</h5>
                            </Col>
                        </Row>
                        <article className="text-center pt-3 pb-3">
                            <h6 className="text-grey mt-3 mb-3">You didn't apply for a job yet.</h6>
                            <Link 
                                onClick={e=>{
                                    window.scrollTo({ top: 0, behavior: 'smooth' })
                                    }} 
                                to={{
                                    pathname : '/searchResults',
                                    search : '',
                                    state : ''
                                }}>
                                <Button  size="large" varient="outlined" className="btn-orange-gradiant text-white pr-5 pl-5">Find a job</Button>
                            </Link>
                        </article>
                    </Paper>
                </Container>
            </div>)
        }
        else{
            return(
                <div>
                    <Container className="pt-5">
                        <Paper elevation={3}>
                            <Row elevation={3} className="bg-light m-0 p-3" style={{borderBottom:'1px solid #f2f2f2'}}>
                                    <Col xs={6}>
                                        <h5>Latest Jobs</h5>
                                    </Col>
                                    <Col className="text-right" xs={6}>
                                        <h5><Link className="text-orange" onClick={e=> window.scrollTo({top : 0 , behavior :'smooth'})} to='/myJobs'>See All <ArrowForwardIcon /></Link></h5>
                                    </Col>
                            </Row>
                            <Row>
                                {
                                    jobs.map(item=>
                                    <Col md='12' key={item.job.id} className="pt-3 pb-3" style={{borderBottom:'1px solid #f2f2f2'}}>
                                        <CardJob data={item.job}/>
                                    </Col>)
                                }
                            </Row>
                        </Paper>
                    </Container>
                </div>
            );
        }    
}
}